// Adapted from http://explainxkcd.com/wiki/index.php/1417:_Seven
const SETS = [
	{
		name: 'seven dwarfs',
		items: [
			'Doc',
			'Grumpy',
			'Happy',
			'Sleepy',
			'Bashful',
			'Sneezy',
			'Dopey',
		],
	},
	{
		name: 'taxonomic ranks',
		items: [
			'kingdom',
			'phylum',
			'class',
			'order',
			'family',
			'genus',
			'species',
		],
	},
	{
		name: 'continents',
		items: [
			'Asia',
			'Africa',
			'North America',
			'South America',
			'Antartica',
			'Europe',
			'Australia',
		],
	},
	{
		name: 'deadly sins',
		items: [
			'lust',
			'gluttony',
			'greed',
			'sloth',
			'wrath',
			'envy',
			'pride',
		],
	},
	{
		name: 'layers in seven-layer dip',
		items: [
			'refried beans',
			'guacamole',
			'sour cream',
			'salsa',
			'cheese',
			'olives',
			'ground beef',
		],
	},
	{
		name: 'layers of the OSI model',
		items: [
			'physical',
			'data link',
			'network',
			'transport',
			'session',
			'presentation',
			'application',
		],
	},
	{
		name: 'Seven Wonders of the Ancient World',
		items: [
			'Colossus of Rhodes',
			'Great Pyramid of Giza',
			'Hanging Gardens of Babylon',
			'Lighthouse of Alexandria',
			'Mausoleum at Halicarnassus',
			'Statue of Zeus at Olympia',
			'Temple of Artemis at Ephesus',
		],
	},
	{
		name: 'days of the week',
		items: [
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
			'Sunday',
		],
	},
	{
		name: 'Seven Seas',
		items: [
			'Pacific Ocean',
			'Atlantic Ocean',
			'Indian Ocean',
			'Arctic Ocean',
			'Mediterranean Sea',
			'Caribbean Sea',
			'Gulf of Mexico',
		],
	},
	{
		name: 'Seven Sisters',
		items: [
			'Mount Holyoke',
			'Vassar',
			'Wellesley',
			'Smith',
			'Radcliffe',
			'Bryn Mawr',
			'Barnard',
		],
	},
	{
		name: 'colors of the rainbow',
		items: [
			'red',
			'orange',
			'yellow',
			'green',
			'blue',
			'indigo',
			'violet',
		],
	},
	{
		name: 'Pleiades',
		items: [
			'Maia',
			'Electra',
			'Taygeta',
			'Alcyone',
			'Celaeno',
			'Sterope',
			'Merope',
		],
	},
	{
		name: '7 Habits of Highly Effective People',
		items: [
			'be proactive',
			'begin with the end in mind',
			'put first things first',
			'think win-win',
			'seek first to understand, then to be understood',
			'synergize',
			'sharpen the saw',
		],
	},
	{
		name: 'seven seals',
		items: [
			'first seal',
			'second seal',
			'third seal',
			'fourth seal',
			'fifth seal',
			'sixth seal',
			'seventh seal',
		],
	},
];
export default SETS;
